import React, { createContext, useEffect, useState } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import FeatureService from 'services/featureToggles';
import { logger } from 'utils';

export interface FeatureToggles {
  [key: string]: string | number | boolean;
}

export const defaultToggles = {};

export const FeatureTogglesContext = createContext<FeatureToggles>(defaultToggles);

const isProd = process.env.REACT_APP_STAGE === 'production';

export const FeatureTogglesProvider: React.FC = ({ children }) => {
  const [features, setFeatures] = useState<FeatureToggles>(defaultToggles);
  const featureService = new FeatureService();
  const [featureQuery, setFeatureQuery] = useQueryParam('feature', StringParam);

  useEffect(() => {
    async function getToggles() {
      const toggles = await featureService.getToggles();
      // Only allow overriding feature toggles through query params in non-prod env.

      if (featureQuery && !isProd) {
        const parsedOverride = featureQuery.replace(
          /(\w+:)|(\w+ :)/g,
          match => `"${match.slice(0, -1)}":`
        );
        try {
          const overrides = JSON.parse(`{${parsedOverride}}`);
          setFeatures({ ...toggles, ...overrides });
        } catch (err) {
          logger.error('Loading feature toggles overrides failed.', err);
          setFeatures(toggles);
        }
        // Clears the "feature" query parameter from the url
        setFeatureQuery(undefined);
      } else {
        setFeatures(toggles);
      }
    }

    getToggles();
    // eslint-disable-next-line
  }, []);

  return (
    <FeatureTogglesContext.Provider value={features}>{children}</FeatureTogglesContext.Provider>
  );
};

export default FeatureTogglesProvider;
